import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxConsumerCreditReportRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxConsumerCreditReportRequest } from '../../requests/runEquifaxConsumerCreditReportRequest';

export const useRunEquifaxConsumerCreditReportRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxConsumerCreditReportRequest) =>
      runEquifaxConsumerCreditReportRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxConsumerCreditReportRequest: mutateAsync, ...rest };
};
